export const DENTAL_SPECIALTIES = [
  'Odontología General',
  'Endodoncia',
  'Ortodoncia',
  'Cirugía Maxilofacial',
  'Periodoncia',
  'Odontopediatría',
  'Prostodoncia',
  'Implantología',
  'General',
];

export const NUTRICION_SPECIALTIES = [
  'Nutrición Clínica',
  'Nutrición Deportiva',
  'Nutrición Pediátrica',
  'Nutrición Oncológica',
];

export const isDental = (especialidad) =>
  DENTAL_SPECIALTIES.includes(especialidad);

export const isNutricion = (especialidad) =>
  NUTRICION_SPECIALTIES.includes(especialidad);
